export default __webpack_public_path__ + "static/media/icon_menu.7ac37460.svg";